import React, { ComponentProps, forwardRef } from "react";
import {
  CpBadgeLegacy,
  CpBadgeLegacyProps,
  legacyIntents,
  CpBadgeLegacyIntent,
} from "./cp-badge-legacy/cp-badge-legacy.component";
import { CpIconDynamic } from "../cp-icon/cp-icon.component";
import { always, tw } from "src/utils";
import { CpBadgeContent } from "./cp-badge-variants/cp-badge-content";
import { CpBadgeVariants } from "./cp-badge-variants/cp-badge-variant";

export type CpBadgeIntent =
  | "base"
  | "neutral"
  | "brand"
  | "brand-alt"
  | "success"
  | "critical"
  | "warning";

export type CpBadgeProps = {
  iconLeft?: CpIconDynamic;
  iconOnly?: CpIconDynamic;
  iconRight?: CpIconDynamic;
  intent: CpBadgeIntent | CpBadgeLegacyIntent;
  size?: "sm" | "md";
} & ComponentProps<"div">;

const intents: readonly CpBadgeIntent[] = [
  "base",
  "neutral",
  "brand",
  "brand-alt",
  "success",
  "critical",
  "warning",
];

export const CpBadge = forwardRef<HTMLDivElement, CpBadgeProps>(
  (props, ref) => {
    const {
      children,
      className,
      iconLeft,
      iconOnly,
      iconRight,
      intent = "base",
      size = "md",
      ...rest
    } = props;

    if (legacyIntents.includes(intent as CpBadgeLegacyIntent)) {
      console.warn(
        `CpBadge intent prop {intent="${intent}"} is deprecated, use ${intents} instead`,
      );
      return (
        <CpBadgeLegacy
          intent={intent as CpBadgeLegacyProps["intent"]}
          {...rest}
        >
          {children}
        </CpBadgeLegacy>
      );
    }
    if (!intents.includes(intent as CpBadgeIntent)) {
      console.warn(
        `CpBadge requires valid intent prop ${intents}`,
        `but got "${intent}"`,
      );
    }

    return (
      <div
        className={always(
          tw(
            CpBadgeVariants({
              iconOnly: !!iconOnly,
              intent: intent as CpBadgeIntent,
              size,
            }),
          ),
          className,
        )}
        ref={ref}
        {...rest}
      >
        <CpBadgeContent
          iconLeft={iconLeft}
          iconOnly={iconOnly}
          iconRight={iconRight}
          size={size}
        >
          {children}
        </CpBadgeContent>
      </div>
    );
  },
);
